// extracted by mini-css-extract-plugin
export default {"wrapper":"zy-z","addressLine":"Ay-z","fullName":"By-z"};